module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'n129332q',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
